module.exports = __webpack_public_path__ + "static/media/id_card.d2258ea3.svg";